import {
  createComponentMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

export const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'WithoutOverlay') {
    return 'WithoutOverlay';
  }
  return undefined;
});

export const stateRefs = withStateRefsValues(['experiments']);

export default createComponentMapperModel({ uiType, stateRefs });
